import $ from '../js/jquery3.4.1'

export function Navigation(){

	
    $('.menu-bar').on("click", function () {
	
		$(".contenido").toggleClass("abrir");
		alternaColorIcono();
	});
	function alternaColorIcono() {
		if ($(".menu-bar").hasClass("icon-cerrar")) {
			$(".menu-bar").css("background-color", "#00326E");
			$(".menu-bar").toggleClass("icon-menu icon-cerrar");
			$(".sidebar").css("display","none")
	
		} else if ($(".menu-bar").hasClass("icon-menu")) {
			$(".menu-bar").css("background-color", "rgb(255, 96, 87)");
			$(".menu-bar").toggleClass("icon-menu icon-cerrar");
			$(".sidebar").css("display","block")
		}
		
	}

	$(document).ready(function(){
		$(".sidebar-dropdown > a").click(function () {

			$(this).parent().children('.sidebar-submenu').slideUp(100);
			
			$(this).find('.flechamenu').toggleClass("desplegado cerrado");
	
			if ($(this).parent().hasClass("active")) {
				$(this).parent().removeClass("active");
			}else{
				$(this).parent().addClass("active");
				$(this).parent().children('.sidebar-submenu').slideDown(100);
			}
		});

		$(".itemNavContenido").click(function(){
			$(".contenido").toggleClass("abrir");
			alternaColorIcono();
		})

		
	})
}